import React from 'react'
import * as reactstrap from 'reactstrap'
import _ from 'common-tools/LodashHelper'
const { Col: RSCol } = reactstrap

export const Col = ({ hide, children, layout, ...rest }) => {
  if (hide === true) {
    return null
  }

  if (layout) {
    let colLayout = { ...layout }

    if (_.isNumber(layout.all)) {
      colLayout = { sm: layout.all, md: layout.all, lg: layout.all, xl: layout.all }
    }
    return <RSCol {...colLayout} {...rest}>{children}</RSCol>
  } else {
    return <RSCol {...rest}>{children}</RSCol>
  }
}
